var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoMultiproposito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 394 59.3",
    style: {
      enableBackground: "new 0 0 394 59.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;stroke:#231F20;stroke-width:1.06;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 5.4,
    className: "st0",
    width: 9.4,
    height: 38.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 5.4,
    className: "st0",
    width: 9.4,
    height: 38.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 5.4,
    className: "st0",
    width: 9.4,
    height: 38.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 5.4,
    className: "st0",
    width: 9.4,
    height: 38.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.5,5.4 34.2,5.4 20.6,23.9 10.3,23.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.2,5.4 92.9,5.4 64.5,43.8 64.5,27.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21,25.3 10.3,25.3 23.9,43.8 34.2,43.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "129,3 123.2,10 134.1,23.9 144.4,23.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "133.7,25.3 144.4,25.3 129,45.2 122.7,38.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 5.4,
    className: "st0",
    width: 14.8,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 20.2,
    className: "st0",
    width: 9,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 35.4,
    className: "st0",
    width: 14.8,
    height: 8.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.3,19.7c0.8,0.8,1.8,1.1,3.2,1.1c1.3,0,2.4-0.4,3.1-1.1c0.8-0.8,1.1-1.8,1.1-3.1V6.7h3.4v9.9 c0,1.5-0.3,2.7-0.9,3.8c-0.6,1.1-1.5,1.9-2.7,2.5c-1.2,0.6-2.5,0.9-4.1,0.9c-1.6,0-3-0.3-4.1-0.9c-1.2-0.6-2.1-1.4-2.7-2.5 s-0.9-2.3-0.9-3.8V6.7h3.4v9.9C161.1,17.9,161.5,18.9,162.3,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.4,9.8c-0.9-0.3-1.8-0.4-2.5-0.4c-0.8,0-1.4,0.1-1.9,0.4c-0.5,0.3-0.7,0.7-0.7,1.2c0,0.5,0.2,0.9,0.5,1.2 c0.3,0.3,0.7,0.6,1.2,0.8c0.5,0.2,1.2,0.4,2,0.7c1.2,0.3,2.2,0.7,2.9,1c0.8,0.3,1.4,0.8,2,1.5c0.5,0.7,0.8,1.5,0.8,2.6 c0,1-0.3,1.9-0.9,2.7c-0.6,0.8-1.4,1.3-2.4,1.7c-1,0.4-2.2,0.6-3.5,0.6c-1.4,0-2.7-0.2-4-0.7c-1.3-0.5-2.5-1.1-3.4-2l1.4-2.7 c0.9,0.8,1.9,1.4,3,1.8s2.1,0.7,3.1,0.7c0.9,0,1.7-0.2,2.2-0.5c0.5-0.3,0.8-0.8,0.8-1.4c0-0.5-0.2-0.9-0.5-1.2 c-0.3-0.3-0.7-0.6-1.2-0.8c-0.5-0.2-1.2-0.4-2.1-0.6c-1.2-0.3-2.2-0.7-2.9-1c-0.8-0.3-1.4-0.8-1.9-1.5c-0.5-0.6-0.8-1.5-0.8-2.6 c0-1,0.3-1.8,0.8-2.6c0.5-0.7,1.3-1.3,2.3-1.7s2.2-0.6,3.5-0.6c1.1,0,2.3,0.2,3.4,0.5c1.1,0.3,2.1,0.8,3,1.3l-1.4,2.8 C187.3,10.5,186.4,10.1,185.4,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,7.6c1.4,0.8,2.6,1.8,3.4,3.1s1.2,2.8,1.2,4.4c0,1.6-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.1 c-1.4,0.8-3,1.2-4.8,1.2c-1.7,0-3.3-0.4-4.8-1.2c-1.4-0.8-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4c0-1.6,0.4-3.1,1.2-4.4 c0.8-1.3,2-2.3,3.4-3.1s3-1.1,4.8-1.1C202.7,6.5,204.3,6.8,205.7,7.6z M198,10.1c-0.9,0.5-1.7,1.2-2.2,2.1 c-0.5,0.9-0.8,1.8-0.8,2.9c0,1.1,0.3,2,0.8,2.9c0.5,0.9,1.3,1.6,2.2,2.1c0.9,0.5,1.9,0.8,3,0.8c1.1,0,2-0.3,3-0.8 c0.9-0.5,1.6-1.2,2.2-2.1c0.5-0.9,0.8-1.8,0.8-2.9c0-1.1-0.3-2-0.8-2.9c-0.5-0.9-1.2-1.6-2.2-2.1c-0.9-0.5-1.9-0.8-3-0.8 C199.9,9.3,198.9,9.6,198,10.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158,30.1h3.9l5.8,10.8l5.8-10.8h3.9v16.8h-3.1V34.8l-5.5,10.3h-2.2l-5.5-10.3v12.1H158V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186,43.1c0.8,0.8,1.8,1.1,3.2,1.1c1.3,0,2.4-0.4,3.1-1.1c0.8-0.8,1.1-1.8,1.1-3.1v-9.9h3.4V40 c0,1.5-0.3,2.7-0.9,3.8c-0.6,1.1-1.5,1.9-2.7,2.5s-2.5,0.9-4.1,0.9c-1.6,0-3-0.3-4.1-0.9c-1.2-0.6-2.1-1.4-2.7-2.5 c-0.6-1.1-0.9-2.3-0.9-3.8v-9.9h3.4V40C184.8,41.3,185.2,42.4,186,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.8,30.1h3.4V44h7.6v2.9h-11V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.5,30.1h14.4V33h-5.5v14H218V33h-5.5V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.3,30.1h3.4v16.8h-3.4V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,31.6c1.2,1,1.8,2.4,1.8,4.3c0,1.9-0.6,3.4-1.8,4.5c-1.2,1.1-2.9,1.6-5.2,1.6h-3.9v4.9H237V30.1h7.2 C246.4,30.1,248.1,30.6,249.4,31.6z M247,38.3c0.7-0.5,1-1.3,1-2.4c0-1-0.3-1.8-1-2.3c-0.7-0.5-1.7-0.8-2.9-0.8h-3.7v6.2h3.7 C245.3,39.1,246.3,38.9,247,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265,46.9l-3.1-5c-0.1,0-0.3,0-0.6,0h-4v4.9H254V30.1h7.4c2.3,0,4.1,0.5,5.3,1.5c1.2,1,1.9,2.4,1.9,4.3 c0,1.3-0.3,2.4-0.9,3.4c-0.6,0.9-1.5,1.6-2.6,2.1l3.9,5.6H265z M257.4,39.1h4c1.3,0,2.3-0.3,2.9-0.8c0.7-0.5,1-1.3,1-2.4 c0-1-0.3-1.8-1-2.3c-0.7-0.5-1.6-0.8-2.9-0.8h-4V39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,31c1.4,0.8,2.6,1.8,3.4,3.1c0.8,1.3,1.2,2.8,1.2,4.4s-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.1 c-1.4,0.8-3,1.2-4.8,1.2c-1.7,0-3.3-0.4-4.8-1.2c-1.4-0.8-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.2-4.4s2-2.3,3.4-3.1 c1.4-0.8,3-1.1,4.8-1.1C282,29.9,283.6,30.3,285,31z M277.3,33.5c-0.9,0.5-1.7,1.2-2.2,2.1s-0.8,1.8-0.8,2.9s0.3,2,0.8,2.9 c0.5,0.9,1.3,1.6,2.2,2.1s1.9,0.8,3,0.8c1.1,0,2-0.3,3-0.8c0.9-0.5,1.6-1.2,2.2-2.1c0.5-0.9,0.8-1.8,0.8-2.9s-0.3-2-0.8-2.9 c-0.5-0.9-1.2-1.6-2.2-2.1c-0.9-0.5-1.9-0.8-3-0.8C279.2,32.8,278.2,33,277.3,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,31.6c1.2,1,1.8,2.4,1.8,4.3c0,1.9-0.6,3.4-1.8,4.5c-1.2,1.1-2.9,1.6-5.2,1.6H296v4.9h-3.4V30.1h7.2 C302.1,30.1,303.8,30.6,305,31.6z M302.6,38.3c0.7-0.5,1-1.3,1-2.4c0-1-0.3-1.8-1-2.3c-0.7-0.5-1.7-0.8-2.9-0.8H296v6.2h3.7 C300.9,39.1,301.9,38.9,302.6,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.4,31c1.4,0.8,2.6,1.8,3.4,3.1c0.8,1.3,1.2,2.8,1.2,4.4s-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.1 c-1.4,0.8-3,1.2-4.8,1.2c-1.7,0-3.3-0.4-4.8-1.2c-1.4-0.8-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.2-4.4s2-2.3,3.4-3.1 c1.4-0.8,3-1.1,4.8-1.1C319.4,29.9,321,30.3,322.4,31z M314.7,33.5c-0.9,0.5-1.7,1.2-2.2,2.1s-0.8,1.8-0.8,2.9s0.3,2,0.8,2.9 c0.5,0.9,1.3,1.6,2.2,2.1s1.9,0.8,3,0.8c1.1,0,2-0.3,3-0.8c0.9-0.5,1.6-1.2,2.2-2.1c0.5-0.9,0.8-1.8,0.8-2.9s-0.3-2-0.8-2.9 c-0.5-0.9-1.2-1.6-2.2-2.1c-0.9-0.5-1.9-0.8-3-0.8C316.6,32.8,315.6,33,314.7,33.5z M318.6,25.1l3.2,1.2l-3.2,2.5l-2.5-0.2 L318.6,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.3,33.2c-1-0.3-1.8-0.4-2.5-0.4c-0.8,0-1.4,0.1-1.9,0.4s-0.7,0.7-0.7,1.2c0,0.5,0.2,0.9,0.5,1.2 c0.3,0.3,0.7,0.6,1.2,0.8c0.5,0.2,1.2,0.4,2,0.7c1.2,0.3,2.2,0.7,2.9,1c0.8,0.3,1.4,0.8,2,1.5c0.5,0.7,0.8,1.5,0.8,2.6 c0,1-0.3,1.9-0.9,2.7s-1.4,1.3-2.4,1.7s-2.2,0.6-3.5,0.6c-1.4,0-2.7-0.2-4-0.7c-1.3-0.5-2.5-1.1-3.4-2l1.4-2.7 c0.9,0.8,1.9,1.4,3,1.8s2.1,0.7,3.1,0.7c0.9,0,1.7-0.2,2.2-0.5c0.5-0.3,0.8-0.8,0.8-1.4c0-0.5-0.2-0.9-0.5-1.2 c-0.3-0.3-0.7-0.6-1.2-0.8s-1.2-0.4-2.1-0.6c-1.2-0.3-2.2-0.7-2.9-1c-0.8-0.3-1.4-0.8-1.9-1.5c-0.5-0.6-0.8-1.5-0.8-2.6 c0-1,0.3-1.8,0.8-2.6c0.5-0.7,1.3-1.3,2.3-1.7s2.2-0.6,3.5-0.6c1.1,0,2.3,0.2,3.4,0.5s2.1,0.8,3,1.3l-1.4,2.8 C340.2,33.9,339.3,33.5,338.3,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.9,30.1h3.4v16.8h-3.4V30.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.6,30.1H366V33h-5.5v14h-3.4V33h-5.5V30.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.2,31c1.4,0.8,2.6,1.8,3.4,3.1c0.8,1.3,1.2,2.8,1.2,4.4s-0.4,3.1-1.2,4.4c-0.8,1.3-2,2.4-3.4,3.1 s-3,1.2-4.8,1.2s-3.3-0.4-4.8-1.2s-2.6-1.8-3.4-3.1c-0.8-1.3-1.2-2.8-1.2-4.4s0.4-3.1,1.2-4.4c0.8-1.3,2-2.3,3.4-3.1 c1.4-0.8,3-1.1,4.8-1.1S378.8,30.3,380.2,31z M372.5,33.5c-0.9,0.5-1.7,1.2-2.2,2.1c-0.5,0.9-0.8,1.8-0.8,2.9s0.3,2,0.8,2.9 c0.5,0.9,1.3,1.6,2.2,2.1s1.9,0.8,3,0.8c1.1,0,2-0.3,2.9-0.8s1.6-1.2,2.2-2.1c0.5-0.9,0.8-1.8,0.8-2.9s-0.3-2-0.8-2.9 c-0.5-0.9-1.2-1.6-2.2-2.1c-0.9-0.5-1.9-0.8-2.9-0.8C374.4,32.8,373.4,33,372.5,33.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoMultiproposito);
export default __webpack_public_path__ + "static/media/kive-uso-multiproposito.fc22bd8956d7fd360fc9906a79365b4c.svg";
export { ForwardRef as ReactComponent };